import {
  CloseOutlined,
  DownloadOutlined,
  EyeOutlined,
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileZipOutlined,
} from '@ant-design/icons';
import { Button, Image, Modal, notification, Tooltip } from 'antd';
import React, { useCallback, useState } from 'react';

interface FileViewerProps {
  documentPath: string;
}

const FileViewer: React.FC<FileViewerProps> = ({ documentPath }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [iframeSrc, setIframeSrc] = useState<string | null>(null);

  const getFileExtension = (url: string): string | null => {
    const match = url?.match(/\.(\w+)(?:\?|$)/);

    return match ? match[1].toLowerCase() : null;
  };

  const extension = getFileExtension(documentPath);

  const handleOpenModal = useCallback(() => {
    // Set iframe source only when opening the modal to prevent unnecessary reloads.
    const uniqueUrl = `${documentPath}?t=${new Date().getTime()}`;
    setIframeSrc(
      `https://docs.google.com/gview?url=${uniqueUrl}&embedded=true`,
    );
    setIsModalVisible(true);
  }, [documentPath]);

  const handleCloseModal = () => {
    setIsModalVisible(false);
    setIframeSrc(null);
  };

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = documentPath;
    a.download = '';
    a.click();
    notification.info({
      message: 'Download started',
      description: 'The file is being downloaded.',
      duration: 3,
    });
  };

  const renderHoverButtons = () => (
    <div className='sbmltybx'>
      <Tooltip title='View'>
        <Button
          type='link'
          onClick={handleOpenModal}
          style={{ color: '#fff', fontSize: '18px' }}
        >
          <EyeOutlined
            className='heheasdasd'
            style={{ height: '20px !important', width: '20px !important' }}
          />
        </Button>
      </Tooltip>
      <Tooltip title='Download'>
        <Button
          type='link'
          onClick={handleDownload}
          icon={
            <DownloadOutlined
              style={{ height: '20px !important', width: '20px !important' }}
            />
          }
          style={{ color: '#fff', fontSize: '18px' }}
        />
      </Tooltip>
    </div>
  );

  if (['jpg', 'jpeg', 'png', 'gif'].includes(extension!)) {
    return <Image src={documentPath} alt='Document' />;
  }
  if (extension === 'zip') {
    return (
      <div>
        <Tooltip title='Download'>
          <Button
            type='link'
            onClick={handleDownload}
            icon={<FileZipOutlined />}
            style={{ display: 'flex', alignItems: 'center' }}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Button
        type='link'
        icon={
          extension === 'pdf' ? (
            <FilePdfOutlined />
          ) : ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'csv'].includes(
              extension!,
            ) ? (
            <FileExcelOutlined />
          ) : (
            <FileOutlined />
          )
        }
        style={{ fontSize: '32px', color: '#1890ff' }}
      />
      {isHovered && renderHoverButtons()}

      <Modal
        title='Document Viewer'
        visible={isModalVisible}
        onCancel={handleCloseModal}
        footer={null}
        closeIcon={<CloseOutlined />}
        width='80%'
        style={{ top: 20, maxWidth: '500px' }}
      >
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            width='100%'
            height='450px'
            style={{ border: 'none' }}
            title='Document Viewer'
            aria-label='Document Viewer'
          />
        )}
      </Modal>
    </div>
  );
};

export default FileViewer;
